export default "__VITE_ASSET__ec927c6b__"